import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactCountryFlag from 'react-country-flag';

const CustomDropdown = ({ options, value, onChange, shouldDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (lang) => {
    onChange(lang);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown" style={{ position: 'relative' }}>
      <button
        type="button"
        className="selected-option"
        onClick={() => setIsOpen(!isOpen)}
        style={{ border: '1px solid #ccc', padding: '8px', cursor: 'pointer', background: 'none' }}
        disabled={shouldDisabled}
      >
        <ReactCountryFlag countryCode={options.find(option => option.lang === value).countryCode} svg style={{ marginRight: '8px' }} />
        {options.find(option => option.lang === value).name} ({options.find(option => option.lang === value).countryCode})
      </button>
      {isOpen && (
        <div className="dropdown-options" style={{ position: 'absolute', top: '100%', left: '0', border: '1px solid #ccc', marginTop: '4px', backgroundColor: '#fff', zIndex: 1000 }}>
          {options.map(option => (
            <button
              key={option.lang}
              className="dropdown-option"
              onClick={() => handleSelect(option.lang)}
              style={{ padding: '8px', cursor: 'pointer', background: 'none', border: 'none', textAlign: 'left', width: '100%' }}
            >
              <ReactCountryFlag countryCode={option.countryCode} svg style={{ marginRight: '8px' }} />
              {option.name} ({option.countryCode})
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    lang: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  shouldDisabled: PropTypes.bool
};

export default CustomDropdown;